import { Page } from '@dixa/lib-shared-habla';
import { electron } from 'lib-shared-electron';

import { isWebHidSupportedInBrowser } from '../../utils/isWebHidSupportedInBrowser';

import { DevicesSection } from './components/devicesSection/devicesSection';
import { GuideSection } from './components/guideSection/guideSection';
import { WebHIDBanner } from './components/webHIDBanner/webHIDBanner';

export const JabraView = (): JSX.Element => {
  return (
    <>
      {!electron.isElectron() && <Page.Section callout={<WebHIDBanner />} />}
      {(electron.isElectron() || isWebHidSupportedInBrowser()) && (
        <>
          <GuideSection />
          <DevicesSection />
        </>
      )}
    </>
  );
};
